import React from 'react';

import { NoDataMessage } from '@/components/NoDataCard';

interface EmptyStateProps {
  title?: string;
  text?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'Recaging results will appear here',
  text = 'Enter in the required number of animals per cage above and click generate to continue.',
}) => {
  return (
    <div className="ui-card">
      <NoDataMessage title={title} text={text} />
    </div>
  );
};
